import { useContext } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";

import {
  confirmForgetPasswordUserValidation,
  forgetPasswordUserValidation,
} from "../../../utils/validation/validation";
import { logo } from "../../../assets";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ValidationErrorMessage from "../../../helpers/ValidationErrorMessage/ValidationErrorMessage";

import { authContext } from "../../../context/AuthContext/AuthContext";

import { HiEye, HiEyeOff } from "react-icons/hi";

const ForgetPassword = ({ setChangeFormPage }) => {
  const {
    isShowPassForgetPass,
    setIsShowPassForgetPass,
    isShowPassForgetPassConfirm,
    setIsShowPassForgetPassConfirm,
    phonenumber,
    isReceiveCode,
    handleForgetPassword,
    handleConfirmForgetPassword,
  } = useContext(authContext);

  // Validation Forget Password
  const {
    register: registerForm1,
    handleSubmit: handleSubmitForm1,
    formState: { errors: errorsForm1 },
  } = useForm({
    resolver: yupResolver(forgetPasswordUserValidation),
  });

  // Validation Confirm Forget Password
  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    formState: { errors: errorsForm2 },
  } = useForm({
    resolver: yupResolver(confirmForgetPasswordUserValidation),
  });

  return (
    <>
      <SiteTitle title="تغییر رمز عبور حساب کاربری" />
      <motion.div
        initial={{ opacity: 0, rotateY: 180 }}
        animate={{
          opacity: 1,
          rotateY: 0,
          transition: {
            duration: 1,
          },
        }}
        className="2xl:w-3/12 xl:w-4/12 lg:w-5/12 md:w-6/12 sm:w-7/12
        w-10/12 py-5 flex flex-col bg-boxColor rounded-2xl"
      >
        <div className="flex items-center w-full px-6 mx-auto">
          <div className="flex-1">
            {/* Logo */}
            <div className="flex justify-center items-center mb-8">
              <img
                src={logo}
                alt="Website Logo"
                className="rounded-full bg-cover w-28 h-28"
              />
            </div>
            {/* Title */}
            <div className="text-center flex justify-center ">
              <h2 className="text-2xl font-bold text-center cursor-pointer text-white">
                تغییر رمز عبور
              </h2>
            </div>
            {/* Forget Password */}
            {!isReceiveCode && (
              <>
                <div className="mt-8">
                  <form
                    onSubmit={handleSubmitForm1(handleForgetPassword)}
                    className="space-y-6"
                  >
                    {/* Phone Number  */}
                    <div>
                      <label
                        htmlFor="phonenumber"
                        className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                      >
                        شماره موبایل
                      </label>
                      <input
                        type="number"
                        name="phonenumber"
                        placeholder="09123456789"
                        autoComplete="off"
                        {...registerForm1("phonenumber")}
                        className="block w-full px-4 py-2 mt-2 border rounded-md
                      placeholder-gray-600 bg-zinc-900 text-gray-400 lg:text-md text-sm
                      border-zinc-900 focus:border-gray-200 tracking-widest mb-2 text-left
                      focus:outline-none focus:text-gray-200 font-medium"
                      />
                      <span>
                        <ValidationErrorMessage
                          message={errorsForm1.phonenumber?.message}
                        />
                      </span>
                    </div>
                    {/* Button */}
                    <div>
                      <button
                        type="submit"
                        className="w-full px-4 py-2 tracking-wide text-white font-medium
           transition-colors duration-200 transform rounded-md
           bg-green-500 hover:bg-green-600 focus:outline-none"
                      >
                        دریافت کد
                      </button>
                    </div>
                  </form>
                  {/* Create Account */}
                  <p className="mt-6 text-sm font-medium text-center text-gray-400">
                    <span
                      onClick={() => setChangeFormPage("signin")}
                      className="text-slate-200 focus:outline-none cursor-pointer"
                    >
                      ورود حساب کاربری
                    </span>
                  </p>
                </div>
              </>
            )}
            {/* Confirm Forget Password */}
            {isReceiveCode && (
              <>
                <div className="mt-8">
                  <form
                    onSubmit={handleSubmitForm2(handleConfirmForgetPassword)}
                    className="space-y-6"
                  >
                    {/* Phone Number  */}
                    <div>
                      <label
                        htmlFor="phoneNumber"
                        className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                      >
                        شماره موبایل
                      </label>
                      <input
                        type="number"
                        name="phoneNumber"
                        disabled="true"
                        readOnly
                        autoComplete="off"
                        value={phonenumber}
                        className="block w-full px-4 py-2 mt-2 border rounded-md
                        placeholder-gray-600 bg-zinc-900 text-gray-400 lg:text-md text-sm
                        border-zinc-900 focus:border-gray-200 tracking-widest mb-2 text-left
                        focus:outline-none focus:text-gray-200 font-medium"
                      />
                      <span>
                        <ValidationErrorMessage
                          message={errorsForm2.phonenumber?.message}
                        />
                      </span>
                    </div>
                    {/* Password */}
                    <div className="relative">
                      <label
                        htmlFor="password"
                        className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                      >
                        رمز عبور
                      </label>
                      <input
                        type={isShowPassForgetPass ? "text" : "password"}
                        name="password"
                        placeholder="******"
                        autoComplete="off"
                        {...registerForm2("password")}
                        className="block w-full px-4 py-2 mt-2 border rounded-md
                        placeholder-gray-600 bg-zinc-900 text-gray-400 lg:text-md text-sm
                        border-zinc-900 focus:border-gray-200 tracking-widest mb-2
                        focus:outline-none focus:text-gray-200 font-medium"
                      />
                      {/* Show/Hide password Icon */}
                      <span className="absolute left-2 top-10">
                        {isShowPassForgetPass ? (
                          <HiEye
                            onClick={() =>
                              setIsShowPassForgetPass(!isShowPassForgetPass)
                            }
                            fill="#fff"
                            className="cursor-pointer"
                          />
                        ) : (
                          <HiEyeOff
                            onClick={() =>
                              setIsShowPassForgetPass(!isShowPassForgetPass)
                            }
                            fill="#fff"
                            className="cursor-pointer"
                          />
                        )}
                      </span>
                      <span>
                        <ValidationErrorMessage
                          message={errorsForm2.password?.message}
                        />
                      </span>
                    </div>
                    {/* Confirm Password */}
                    <div className="relative">
                      <label
                        htmlFor="confirmpassword"
                        className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                      >
                        تکرار رمز عبور
                      </label>
                      <input
                        type={isShowPassForgetPassConfirm ? "text" : "password"}
                        name="confirmpassword"
                        placeholder="******"
                        autoComplete="off"
                        {...registerForm2("confirmpassword")}
                        className="block w-full px-4 py-2 mt-2 border rounded-md
                      placeholder-gray-600 bg-zinc-900 text-gray-400 lg:text-md text-sm
                      border-zinc-900 focus:border-gray-200 tracking-widest mb-2
                      focus:outline-none focus:text-gray-200 font-medium"
                      />
                      {/* Show/Hide Password Icon */}
                      <span className="absolute left-2 top-10">
                        {isShowPassForgetPassConfirm ? (
                          <HiEye
                            onClick={() =>
                              setIsShowPassForgetPassConfirm(
                                !isShowPassForgetPassConfirm
                              )
                            }
                            fill="#fff"
                            className="cursor-pointer"
                          />
                        ) : (
                          <HiEyeOff
                            onClick={() =>
                              setIsShowPassForgetPassConfirm(
                                !isShowPassForgetPassConfirm
                              )
                            }
                            fill="#fff"
                            className="cursor-pointer"
                          />
                        )}
                      </span>
                      <span>
                        <ValidationErrorMessage
                          message={errorsForm2.confirmpassword?.message}
                        />
                      </span>
                    </div>
                    {/* Verify Code  */}
                    <div>
                      <label
                        htmlFor="token"
                        className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                      >
                        کد تأیید
                      </label>
                      <input
                        type="number"
                        name="token"
                        placeholder="*****"
                        autoComplete="off"
                        {...registerForm2("token")}
                        className="block w-full px-4 py-2 mt-2 border rounded-md
                        placeholder-gray-600 bg-zinc-900 text-gray-400 lg:text-md text-sm
                        border-zinc-900 focus:border-gray-200 tracking-widest mb-2 text-center
                        focus:outline-none focus:text-gray-200 font-medium"
                      />
                      <span>
                        <ValidationErrorMessage
                          message={errorsForm2.token?.message}
                        />
                      </span>
                    </div>
                    <p className="text-center mt-2 text-gray-200">
                      زمان باقی مانده
                      <span id="verificationCodeCountDown" className="mx-2">
                        120
                      </span>
                      ثانیه
                    </p>
                    {/* Button */}
                    <div>
                      <button
                        type="submit"
                        className="w-full px-4 py-2 tracking-wide text-white font-medium
           transition-colors duration-200 transform rounded-md
           bg-green-500 hover:bg-green-600 focus:outline-none"
                      >
                        تغییر رمز عبور
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default ForgetPassword;
